<script>
/**
 * Tooltip único da grade de alocações.
 * O estado fica aqui para o hover não re-renderizar a grade inteira (slots dinâmicos por mês).
 */
export default {
  data() {
    return {
      opened: false,
      x: 0,
      y: 0,
      text: ""
    };
  },
  methods: {
    /**
     * Exibe o tooltip acima da célula
     * @param {HTMLElement} element - Célula sob o mouse
     * @param {string} text - Conteúdo (aceita quebras de linha)
     */
    show(element, text) {
      const { left, top, width } = element.getBoundingClientRect();

      this.x = left + width / 2;
      this.y = top;
      this.text = text;
      this.opened = true;
    },
    hide() {
      this.opened = false;
    }
  }
};
</script>

<template>
  <v-tooltip
    v-model="opened"
    absolute
    :position-x="x"
    :position-y="y"
    top
  >
    <span class="allocation-tooltip">{{ text }}</span>
  </v-tooltip>
</template>

<style lang="scss" scoped>
.allocation-tooltip {
  white-space: pre-line;
}
</style>
